import React from "react";
import { UseFormRegister } from "react-hook-form";

export default function InputMobileNumber({
  placeholder,
  register,
  name,
  value,
  readOnly,
  disabled,
}: {
  placeholder: string;
  register: UseFormRegister<any>;
  name: string;
  value?: number | string;
  readOnly?: boolean;
  disabled?: boolean;
}) {
  return (
    <>
      <input
        type="number"
        placeholder={placeholder}
        inputMode="numeric"
        // name={name}
        {...register(name)}
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        className="px-3 py-4 border !border-[#D2D2D2] !rounded-lg w-full ubermoveTextMedium"
      />
    </>
  );
}
